export enum Context {
  SQUAD = 'A&E',
  HERO_USP = 'Hero - USP',
  HERO_TRUSTPILOT = 'Hero - Trustpilot',
  HERO_SEARCH = 'Hero - Search',
  CAR_REVIEW = 'Car Review',
  HERO_HMC = 'Hero - Help Me Choose',
}
